<div class="v-pageName">{{pageName}}</div>

<!-- Client data -->
<div class="body-main">
    <div class="qmig-card">
        <div class="qmig-card-body">
            <div class="custom_search cs-r">
                <span class="mdi mdi-magnify"></span>
                <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchText" (keyup)="onKey()">
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover qmig-table">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Email</th>
                        <th>Migration Type</th>
                        <th>Created Date</th>
                        <th>Summary</th>
                        <th>Status</th>
                        <th>Review</th>
                        <th>Action</th>
                    </tr>

                </thead>
                <tbody>
                    @for (ucList of userData | searchFilter: searchText | paginate: { itemsPerPage: 10, currentPage: p }
                    ; track ucList; let i = $index) {
                    <tr>
                        <td>{{10 *(p-1)+i+1}}</td>
                        <td>{{ucList.email}}</td>
                        <td>{{ucList.mig_name}}</td>
                        <td>{{ucList.created_date}}</td>
                        <td>{{ucList.summary}}</td>
                        <td>
                            @if(ucList.status=='Completed'){
                            <span class="badge badge-csuccess">Completed</span>
                            }@else if(ucList.status=='Reviewed'){
                            <span class="badge badge-cwarning">Reviewed</span>
                            }@else{
                            <span class="badge badge-cdanger">New</span>
                            }
                        </td>
                        <td>
                            <button (click)="navigateTryNowView(ucList)" class="btn btn-download">
                                <span class="mdi mdi-eye btn-icon-prepend"></span>
                            </button>
                        </td>
                        <td>
                            <button class="btn btn-download" data-bs-toggle="offcanvas" data-bs-target="#emailPanel" (click)="openEmailPanel(ucList)">
                                <span class="mdi mdi-email"></span>
                            </button>
                        </td>
                    </tr>
                    }@empty {
                    <tr>
                        <td colspan="8">
                            <p class="text-center m-0 w-100">Empty list</p>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="custom_pagination mt-3">
            <pagination-controls (pageChange)="p = $event"></pagination-controls>
        </div>
    </div>
</div>

<!-- Email Panel Offcanvas -->
<div class="offcanvas offcanvas-end" tabindex="-1" id="emailPanel">
    <div class="offcanvas-header">
        <h4 class="main_h">Send Email</h4>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" (click)="closeEmailPanel()"></button>
    </div>
    
    <div class="offcanvas-body">
        <div class="mb-3">
            <label class="form-label">To:</label>
            <input type="email" class="form-control" [value]="currentUser?.email" readonly>
        </div>
        
        <div class="mb-3">
            <label class="form-label">Subject:</label>
            <input type="text" class="form-control" [(ngModel)]="emailSubject" placeholder="Enter subject" [disabled]="emailLoading">
        </div>
        
        <div class="mb-3">
            <label class="form-label">Body:</label>
            <textarea class="form-control" rows="6" [(ngModel)]="emailBody" placeholder="Enter message" [disabled]="emailLoading"></textarea>
        </div>
        
        @if (emailMessage) {
        <div class="alert" [ngClass]="emailMessageType === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
            {{emailMessage}}
        </div>
        }
        
        <div class="d-flex gap-2 mt-4">
            <button type="button" class="btn btn-default flex-grow-1" data-bs-dismiss="offcanvas" (click)="closeEmailPanel()" [disabled]="emailLoading">
                Cancel
            </button>
            <button type="button" class="btn btn-success flex-grow-1" (click)="sendEmail()" [disabled]="emailLoading">
                @if (emailLoading) {
                <span class="spinner-border spinner-border-sm me-2"></span>
                }
                Send
            </button>
        </div>
    </div>
</div>